<template>
  <span class="jm-areaselect">
    <span v-if="show">{{ showText }}</span>
    <el-select
      v-if="!show"
      v-model="province"
      class="jm-input-common2"
      clearable
      placeholder="请选择"
      @change="changeProvince"
      v-bind="$attrs"
    >
      <el-option
        v-for="item in provinces"
        :label="item.value"
        :value="item.id"
        :key="item.id"/>
    </el-select>
    <el-select
      v-if="!show"
      v-model="city"
      class="jm-input-common2"
      clearable
      placeholder="请选择"
      @change="changeCity"
      v-bind="$attrs"
    >
      <el-option
        v-for="item in cities"
        :label="item.value"
        :value="item.id"
        :key="item.id"/>
    </el-select>
  </span>
</template>

<script>
import Lockr from 'lockr';

export default {
  name: 'JmAreaselect',
  model: {
    event: 'change',
  },
  props: {
    value: [String, Array, Object],
    show: {
      type: Boolean,
      default: false,
    },
    empty: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      provinces: [],
      citiesDs: [],
      province: '',
      city: '',
    };
  },
  computed: {
    showText() {
      let text = '';
      this.provinces.forEach((p) => {
        if (p.id === this.province) {
          text = p.value;
        }
      });
      this.cities.forEach((c) => {
        if (c.id === this.city) {
          text += ` ${c.value}`;
        }
      });
      return text;
    },
    cities() {
      return this.citiesDs.filter((item) => {
        return item.pid === this.province;
      });
    }
  },
  methods: {
    /**
     * 获取城市信息
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @return {Promise}
     */
    getCities() {
      let cities = Lockr.get('citiesDatasource');
      if (!cities) {
        return new Promise((resolve) => {
          this.$http._get({
            url: '/index/api_base/city',
          }).then(({ data }) => {
            Lockr.set('citiesDatasource', data);
            return resolve(data);
          });
        });
      }
      return Promise.resolve(cities);
    },
    getProvince() {
      let provinces = Lockr.get('provinceDatasource');
      if (!provinces) {
        return new Promise((resolve) => {
          this.$http._get({
            url: '/index/api_base/province'
          }).then(({ data }) => {
            Lockr.set('provinceDatasource', data);
            resolve(data);
          });
        });
      }
      return Promise.resolve(provinces);
    },
    changeProvince(v) {
      this.city = '';
      if (!v) {
        this.$emit('change', ['', '']);
        return true;
      }
      if (this.empty) {
        this.cities.unshift({
          id: -1,
          value: '空'
        });
      }
      this.$emit('change', [this.province, this.city]);
    },
    changeCity() {
      this.$emit('change', [this.province, this.city]);
    }
  },
  created() {
    /*
    * 初始化数据
    * */
    this.getProvince().then((data) => {
      this.provinces = data;
      if (this.empty) {
        this.provinces.unshift({
          id: -1,
          value: '空'
        });
      }
    });
    this.getCities().then((data) => {
      this.citiesDs = data;
      if (this.value) {
        this.province = this.value[0];
        this.city = this.value[1];
      }
    });
  },
  watch: {
    value(val) {
      this.province = val[0];
      this.city = val[1];
    },
  }
};
</script>
